import React from 'react';
import styled from '@emotion/styled';
import Modal from '~ComponentsImproved/Modal';
import Heading from '~ComponentsImproved/Typography/Heading';
import { useButton, useI18n } from '~Hooks';
import { handyBreakpoint } from '~Styles/breakpoints';
import { BlackButton, BlueButton } from '~Styles';

const Wrapper = styled.div<{ width: string }>`
  width: ${({ width }) => width};
  text-align: center;
  background-color: var(--colorWhite);
  box-shadow: 0px 0px 12px rgb(0 0 0 / 20%), 0px 20px 32px rgb(0 0 0 / 20%),
    0px 0px 40px rgb(0 0 0 / 16%);
  border-radius: 8px;
  padding: 44px 64px;
  box-sizing: border-box;
  min-height: 248px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;

  ${handyBreakpoint} {
    width: 95%;
    padding: 24px 32px;
  }
`;

const Buttons = styled.div`
  display: flex;
  flex-flow: row nowrap;
  margin: 26px -8px 0;

  button {
    margin: 8px;
  }
`;

const LeftButton = styled(BlackButton)`
  height: 64px;
`;

const RightButton = styled(BlueButton)`
  height: 64px;
`;

export interface Props {
  question: string;
  isShowing: boolean;
  onLeftClick: () => void;
  onRightClick: () => void;
  leftText?: string;
  rightText?: string;
  width?: string;
  backdropClose?: () => void;
}

const QuestionModal: React.FunctionComponent<Props> = ({
  question,
  isShowing,
  onLeftClick,
  onRightClick,
  leftText,
  rightText,
  width = '512px',
  backdropClose,
}) => {
  const { i18n } = useI18n();

  const leftButton = useButton({
    onClick: onLeftClick,
  });

  const rightButton = useButton({
    onClick: onRightClick,
  });

  return (
    <Modal isShowing={isShowing} backdropClose={Boolean(backdropClose)} hide={backdropClose}>
      <Wrapper width={width}>
        <Heading level={3} color="var(--colorBlueGray1200)">
          {question}
        </Heading>
        <Buttons>
          <LeftButton fluid {...leftButton}>
            {leftText ?? i18n('General.No')}
          </LeftButton>
          <RightButton fluid {...rightButton}>
            {rightText ?? i18n('General.Yes')}
          </RightButton>
        </Buttons>
      </Wrapper>
    </Modal>
  );
};

export default QuestionModal;
